// todos模块接口
import registerApi from './user/register';
import memberApi from './member/index';
import dashboardApi from './dashboard/index';
// 其他模块的接口……

// 导出接口
export default {
  registerApi,
  memberApi,
  dashboardApi
  // ……
}



// WEBPACK FOOTER //
// ./src/api/index.js